module.exports = __webpack_public_path__ + "img/emoji-laugh-80x80.4a82b9b3.png";